import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { RootState } from './types';
import { authentication } from './stores/authentication/index';
import { contracts } from './stores/contracts/index';
import { parties } from './stores/parties/index';
import { claims } from './stores/claims/index';
import { party } from './stores/party/index';
import { claim } from './stores/claim/index';
import { users } from './stores/users/index';
import { dashboard } from './stores/dashboard/index';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
      version: '1.0.0',
  },
  modules: {
    authentication,
    users,
    contracts,
    parties,
    claims,
    party,
    claim,
    dashboard,
  },
};

export default new Vuex.Store<RootState>(store);
